<template>
    <footer class="custom-footer">
        <div class="container-fluid text-white p-3">
            <div class="row">
                <div class="col-12 col-md-2 mb-4 mb-md-0">
                    <img src="@/assets/images/logo_verde.png" class="d-inline-block align-top logo" alt="Logo" />
                </div>

                <div class="col-12 col-md-6 mb-4 mb-md-0">
                    <div>
                        <strong>Precisa de ajuda? Fale conosco por Whatsapp</strong>
                    </div>
                    <div class="mt-2">
                        Atendimento de segunda a sexta-feira, das 08h às 17h50.
                    </div>

                    <div class="mt-4 d-flex align-items-center gap-2 justify-content-start">
                        <div class="social-link">
                            <i class="fab fa-whatsapp"></i>
                        </div>
                        <a href="https://wa.me/5548991548297" target="_blank" class="footer-link">
                            <strong>+55 (48) 9 9154-8297</strong>
                        </a>
                    </div>

                    <div class="mt-4 d-flex align-items-center gap-2 justify-content-start">
                        <div class="social-link">
                            <i class="fas fa-phone"></i>
                        </div>
                        <a href="tel:+554832884130" class="footer-link">
                            <strong>+55 (48) 3288-4130</strong>
                        </a>
                    </div>

                    <div class="mb-2 mt-5 d-flex align-items-start justify-content-start">
                        <i class="fas fa-map-marker-alt mt-1 mr-3"></i>
                        <span>Rua Dom Jaime Câmara, 94, Centro - Florianópolis - SC</span>
                    </div>
                </div>

                <div class="col-12 col-md-4">
                    <div>
                        <div class="mb-3">
                            Acompanhe nossas redes sociais
                        </div>
                        <div class="d-flex gap-3 justify-content-start">
                            <a href="https://br.linkedin.com/company/unimed-florianopolis" target="_blank"
                                class="social-link">
                                <i class="fab fa-linkedin-in"></i>
                            </a>
                            <a href="https://www.facebook.com/UnimedFlorianopolis" target="_blank" class="social-link">
                                <i class="fab fa-facebook-f"></i>
                            </a>
                            <a href="https://www.instagram.com/unimedflorianopolis/" target="_blank"
                                class="social-link">
                                <i class="fab fa-instagram"></i>
                            </a>
                        </div>

                        <div class="mt-4 d-flex align-items-center gap-2 justify-content-start">
                            <i class="fas fa-globe mr-3"></i>
                            <a target="_blank" href="https://www.unimed.coop.br/site/web/florianopolis"
                                class="footer-link link-site">
                                Site Unimed Grande Florianópolis
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="separador"></div>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-12 text-footer">
                    Copyright 2025 • Unimed Grande Florianópolis
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'FooterComponent'
}
</script>

<style scoped>
/* Estrutura Principal */
.custom-footer {
    background-color: #00524D;
    font-family: "Trebuchet MS", sans-serif;
    font-size: 16px;
    width: 100%;
    padding: 46px 32px;
    min-height: 300px;
}

.logo {
    width: 130px;
    height: auto;
}

/* Links de Texto */
.footer-link {
    color: #FFFFFF !important;
    text-decoration: none !important;
    font-family: inherit;
    font-size: inherit;
    transition: none !important;
    /* Remove qualquer transição de cor */
}

.link-site {
    text-decoration: underline !important;
}

.footer-link:hover {
    text-decoration: underline !important;
    box-shadow: none !important;
}

/* Círculos dos Ícones (Unificado) */
.social-link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    height: 35px;
    background-color: #003A36 !important;
    border-radius: 50%;
    color: #FFFFFF !important;
    text-decoration: none !important;
    font-size: 18px;
    /* Remove mudanças visuais no hover */
    transition: none;
    margin-right: 5px;
}

.social-link:hover {
    background-color: #003A36 !important;
    color: #FFFFFF !important;
    text-decoration: none !important;
}

/* Elementos de Layout */
.separador {
    border-top: 2px solid #669794;
    width: 100%;
    margin-top: 20px;
}

.text-footer {
    font-size: 10pt !important;
    text-align: center;
}

/* Ajustes de espaçamento de ícones de texto */
.mr-3 {
    margin-right: 1rem !important;
}
</style>